export const UpgradeTrialIcon = ({ dateUntil }: { dateUntil: number }) => {
  const secondsInDay = 86400;
  const now = Math.ceil(new Date().getTime() / 1000);
  const days = Math.ceil((dateUntil - now) / secondsInDay);
  const totalDays = 7;
  const radius = 10;
  const stroke = 2;
  const circumference = 2 * Math.PI * radius;
  const dashOffset = (1 - days / totalDays) * circumference;

  return (
    <div className="relative flex items-center justify-center rounded-[4px] w-[32px] h-[32px] bg-cyan-800">
      <span className="text-white text-[12px] font-bold">{days}</span>
      <svg className="absolute top-[4px] right-[4px] h-[24px] w-[24px] transform scale-x-[-1]" viewBox="0 0 24 24">
        <circle
          style={{ color: '#164E63' }}
          strokeWidth={stroke}
          stroke="currentColor"
          fill="transparent"
          r={radius}
          cx="12"
          cy="12"
        />
        <circle
          style={{ color: '#fff' }}
          strokeWidth={stroke}
          strokeDasharray={circumference}
          strokeDashoffset={dashOffset}
          stroke="currentColor"
          fill="transparent"
          r={radius}
          cx="12"
          cy="12"
          transform="rotate(-90 12 12)"
        />
      </svg>
    </div>
  );
};
